import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from "react-slick";
import { EpisodeItem, ComingSoonItem, IfiItem } from './items';
import { NextArrow, PrevArrow } from './custom-arrows';


class Playlist extends Component {
    constructor(props) {
        super(props);
        require("slick-carousel/slick/slick.css");
        require("slick-carousel/slick/slick-theme.css");
        require("./playlist-styles.scss")
        //console.log("[Playlist] props", props);
    }
    get episodes() {
        return this.props.configs.filter(config => {
            return config.isIfi === false && config.comingsoon === false;
        })
    }

    get playlistItems() {
        const { routing } = this.props;
        const playlistItems = this.props.configs.map((_config, index) => {
            const key = `playlist-item-${index}`;

            let config = Object.assign({}, _config, {
                ref: React.createRef(),
                disableRouting: routing === false
            })
            const { playlistLink, isIfi } = config;
            if (isIfi) {
                if (playlistLink != null && playlistLink.href != null && playlistLink.href.trim().length > 0) {
                    return (
                        <div key={key} className="playlist-item">
                        <IfiItem {...config} onClick={this.handleExternalLinkClick.bind(this)} />
                        </div>
                    )
                } else {
                    return (
                        <div key={key} className="playlist-item">
                        <IfiItem {...config} onClick={this.props.onIfiItemClick}/>
                        </div>
                    )
                }
            } else if (config.comingsoon == false) {
                return (
                    <div key={key} className="playlist-item">
                    <EpisodeItem {...config} onClick={this.props.onEpisodeItemClick} />
                    </div>
                )
            } else {
                return (
                    <ComingSoonItem key={key} {...config}  />
                )
            }
        })
        return playlistItems;
    }


    handleExternalLinkClick(e) {
        const { player } = this.props;

        if (player == null || player.amp == null) {
            return;
        }

        const { playState } = player.amp;

        if (playState != null && playState != "paused" && playState != "ended") {
            player.amp.pause()
        }
    }
    handleSliderBeforeChange(oldIndex, newIndex) {
        this.props.onSliderBeforeChange(oldIndex, newIndex);
    }
    render() {

        const { configs } = this.props;

        const slidesLength = configs.length;

        if (slidesLength === 0) {
            return null;
        } else {
            const { maxTouchPoints } = window.navigator;
            const settings = {
                key: 'mtv-playlist-slider',
                dots: false,
                infinite: false,
                speed: 250,
                slidesToShow: slidesLength < 4 ? slidesLength : 4,
                slidesToScroll: slidesLength < 4 ? slidesLength : 4,
                nextArrow: (<NextArrow />),
                prevArrow: (<PrevArrow />),
                beforeChange: this.handleSliderBeforeChange.bind(this),
                swipe: (maxTouchPoints != null && maxTouchPoints > 1),
                responsive: [{
                    "breakpoint": 1040,
                    "settings": {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }]

            };

            return (
                <section className="mtv-playlist">
                        <h3>Episodes ({this.episodes.length})</h3>
                        <div className="slider-container">
                            <Slider {...settings}>
                                { this.playlistItems }
                            </Slider>
                        </div>
                    </section>
            )
        }
    }
    static get propTypes() {
        return {
            "configs": PropTypes.array,
            "routing": PropTypes.bool,
            "onIfiItemClick": PropTypes.func,
            "onEpisodeItemClick": PropTypes.func,
            "onSliderBeforeChange": PropTypes.func,
            "player": PropTypes.object
        }
    }

    static get defaultProps() {
        return {
            configs: [],
            routing: true,
            onIfiItemClick: () => {},
            onEpisodeItemClick: () => {},
            onSliderBeforeChange: () => {},
            player: null
        }
    }
}


export default Playlist